export default __webpack_public_path__ + "static/media/ss.b05ebd9c.svg";